"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwImage = _interopRequireDefault(require("../../cwimage/CwImage"));

var _CwDataGrid = _interopRequireDefault(require("../CwDataGrid.scss"));

var CellBoolFlags = function CellBoolFlags(props) {
  var cellContent = '--';

  if (props.flags[props.col.key]) {
    cellContent = props.flags[props.col.key].map(function (item, index) {
      return _react.default.createElement("span", {
        "data-cwid": "".concat(item.cwId, "_").concat(props.row[item.value]),
        key: index // eslint-disable-line react/no-array-index-key
        ,
        title: props.row[item.value] ? item.name : item.falseName || item.name
      }, _react.default.createElement(_CwImage.default, {
        className: (0, _classnames.default)(_CwDataGrid.default.cellImage, (0, _defineProperty2.default)({}, _CwDataGrid.default.disabled, !props.row[item.value])),
        src: item.icon
      }));
    });
  }

  return _react.default.createElement("div", {
    "data-cw-grid-cell-custom-flags": true,
    className: (0, _classnames.default)(_CwDataGrid.default.cell, _CwDataGrid.default.cellCustomFlags),
    style: {
      width: props.col.width
    }
  }, cellContent);
};

CellBoolFlags.propTypes = {
  col: _propTypes.default.object.isRequired,
  row: _propTypes.default.object.isRequired,
  flags: _propTypes.default.object.isRequired
};
var _default = CellBoolFlags;
exports.default = _default;